import { render, staticRenderFns } from "./LocationItem.vue?vue&type=template&id=391922ef&scoped=true"
import script from "./LocationItem.ts?vue&type=script&lang=ts&external"
export * from "./LocationItem.ts?vue&type=script&lang=ts&external"
import style0 from "./LocationItem.scss?vue&type=style&index=0&id=391922ef&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391922ef",
  null
  
)

export default component.exports